<template>
<div>
  <div class="wistia_embed wistia_async_vwh2y40fl0">
    &nbsp;
  </div>

  <div
    id="first_step"
    class="tbk-vid-embed"
  >
    <a
      id="opened"
      class="embedded_video"
      href="#wistia_ybx1703q8q?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="ignored"
      class="embedded_video"
      href="#wistia_nqwl8d940g?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>

  <div
    id="second_step"
    class="tbk-vid-embed"
  >
    <a
      id="filled_out"
      class="embedded_video"
      href="#wistia_oep5pm6mvv?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="deleted"
      class="embedded_video"
      href="#wistia_nqwl8d940g?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>

  <div
    id="third_step"
    class="tbk-vid-embed"
  >
    <a
      id="intro"
      class="embedded_video"
      href="#wistia_vwh2y40fl0?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('vwh', 7, this.showFirstStep)
    this.tbk.loadCrossTime('ybx', 9, this.showSecondStep)
    this.tbk.loadCrossTime('f56', 32, this.showThirdStep)
    this.tbk.loadCrossTime('oep', 44, this.showThirdStep)
    this.tbk.loadCrossTime('nqw', 35, this.showThirdStep)

    if (this.tbk.isMobile()) {
      _wq.push({
        vwh: this.tbk.autoPlay,
        ybx: this.tbk.autoPlay,
        f56: this.tbk.autoPlay,
        oep: this.tbk.autoPlay,
        nqw: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showFirstStep() {
      $('#first_step').show()
      this.tbk.hideMobileControls()
    },

    showSecondStep() {
      $('#second_step').show()
      this.tbk.hideMobileControls()
    },

    showThirdStep() {
      $('#third_step').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#first_step,
#second_step,
#third_step
  display: none
  a
    text-decoration: none
#opened
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (17 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#ignored
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (337 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#filled_out
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (17 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#deleted
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (337 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
#intro
  position: absolute
  top: calc(100% * (17 / 360))
  left: calc(100% * (177 / 640))
  width: calc(100% * (285 / 640))
  height: calc(100% * (291 / 360))
</style>
